// tslint:disable-next-line:no-submodule-imports
import 'react-app-polyfill/ie11';

// tslint:disable-next-line:no-submodule-imports
import 'core-js/es/symbol.js';

// tslint:disable-next-line:no-submodule-imports
import 'core-js/es/string/includes.js';

// tslint:disable-next-line:no-submodule-imports
import 'core-js/es/array/find.js';

// tslint:disable-next-line:no-submodule-imports
import 'core-js/es/symbol/iterator.js';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.scss';
import * as serviceWorker from './serviceWorker';

library.add(fal, fas);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
